/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Config_MissingInputs */

const en_us2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We need your training setup before we can build a workout. Finish setting up and try again.`)
};

const pt_br2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisamos da sua configuração de treino antes de montar um treino. Termine o cadastro e tente de novo.`)
};

const es_419_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitamos tu configuración de entrenamiento antes de armar un entrenamiento. Termina el registro e intenta de nuevo.`)
};

const pt_pt2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisamos da tua configuração de treino antes de montar um treino. Termina o registo e tenta outra vez.`)
};

const fr_fr2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nous faut ta configuration d'entraînement avant de créer une séance. Termine la configuration et réessaie.`)
};

const de_de2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir brauchen dein Trainings-Setup, bevor wir ein Training erstellen können. Schließ die Einrichtung ab und versuch es noch mal.`)
};

const it_it2_prescription_config_missing = /** @type {(inputs: Prescription_Config_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci servono le tue impostazioni di allenamento prima di creare un allenamento. Completa la configurazione e riprova.`)
};

/**
* | output |
* | --- |
* | "We need your training setup before we can build a workout. Finish setting up and try again." |
*
* @param {Prescription_Config_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_config_missing = /** @type {((inputs?: Prescription_Config_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Config_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_config_missing(inputs)
	if (locale === "es-419") return es_419_prescription_config_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_config_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_config_missing(inputs)
	if (locale === "de-DE") return de_de2_prescription_config_missing(inputs)
	if (locale === "it-IT") return it_it2_prescription_config_missing(inputs)
	return en_us2_prescription_config_missing(inputs)
});
export { prescription_config_missing as "prescription.config_missing" }